import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "counter", "submit" ]
  // max of 0 means no maximum. With a max, the counter reads "1,234 / 8,000 characters" and turns red past it.
  static values = { min: { type: Number, default: 50 }, max: { type: Number, default: 0 } }

  connect() {
    this.boundUpdate = this.update.bind(this)
    const inputEl = this.getInputElement()
    if (inputEl) {
      inputEl.addEventListener("input", this.boundUpdate)
      inputEl.addEventListener("keyup", this.boundUpdate)
      inputEl.addEventListener("change", this.boundUpdate)
    }
    this.update()
  }

  disconnect() {
    const inputEl = this.getInputElement()
    if (inputEl && this.boundUpdate) {
      inputEl.removeEventListener("input", this.boundUpdate)
      inputEl.removeEventListener("keyup", this.boundUpdate)
      inputEl.removeEventListener("change", this.boundUpdate)
    }
  }

  getInputElement() {
    return this.hasInputTarget ? this.inputTarget : this.element.querySelector("textarea, input[type=text]")
  }

  update(event) {
    const inputEl = (event && event.target && event.target.value !== undefined) ? event.target : this.getInputElement()
    if (!inputEl) return

    const max = this.maxValue
    // With a max, count characters as the server checks them (code points), so an emoji counts once, not twice.
    const length = max > 0 ? Array.from(inputEl.value).length : inputEl.value.length
    const min = this.hasMinValue ? this.minValue : (parseInt(inputEl.getAttribute("minlength"), 10) || 50)
    const tooLong = max > 0 && length > max
    const fits = length >= min && !tooLong

    const counterEl = this.hasCounterTarget ? this.counterTarget : this.element.querySelector(".char-counter")
    if (counterEl) {
      counterEl.textContent = max > 0 ? `${length.toLocaleString()} / ${max.toLocaleString()} characters` : `${length}/${min}`
      if (tooLong) {
        counterEl.className = "char-counter text-red-600 font-semibold"
      } else if (length >= min) {
        counterEl.className = "char-counter text-green-600 font-semibold"
      } else {
        counterEl.className = "char-counter text-gray-400"
      }
    }

    const submitEl = this.hasSubmitTarget ? this.submitTarget : this.element.querySelector("input[type=submit], button[type=submit]")
    if (submitEl) {
      if (fits) {
        submitEl.disabled = false
        submitEl.classList.remove("opacity-50", "cursor-not-allowed")
        submitEl.classList.add("cursor-pointer")
      } else {
        submitEl.disabled = true
        submitEl.classList.add("opacity-50", "cursor-not-allowed")
        submitEl.classList.remove("cursor-pointer")
      }
    }
  }
}
